module.exports = __webpack_public_path__ + "img/eye.567c8f7b.svg";